// Cola de ventas sin conexión + sincronización automática.
import api from "./api";
import { genClientId } from "./offline";

const QKEY = "pos_offline_orders";
export const QUEUE_EVENT = "pos-offline-queue-changed";

function read() {
  try {
    return JSON.parse(localStorage.getItem(QKEY) || "[]");
  } catch {
    return [];
  }
}

function write(list) {
  localStorage.setItem(QKEY, JSON.stringify(list));
  try {
    window.dispatchEvent(new CustomEvent(QUEUE_EVENT, { detail: { count: list.length } }));
  } catch {
    /* ignore */
  }
}

export function pendingCount() {
  return read().length;
}

export function enqueueOrder(payload) {
  const list = read();
  const item = { ...payload, client_order_id: payload.client_order_id || genClientId() };
  list.push(item);
  write(list);
  return item;
}

let syncing = false;

export async function syncNow() {
  if (syncing) return;
  if (typeof navigator !== "undefined" && navigator.onLine === false) return;
  let list = read();
  if (!list.length) return;
  syncing = true;
  try {
    for (const item of list) {
      try {
        await api.post("/orders", item);
        const cur = read().filter((o) => o.client_order_id !== item.client_order_id);
        write(cur);
      } catch (e) {
        const status = e?.response?.status;
        if (status && status >= 400 && status < 500) {
          // El servidor rechazó la venta (datos inválidos): la quitamos para no reintentar en bucle.
          const cur = read().filter((o) => o.client_order_id !== item.client_order_id);
          write(cur);
          continue;
        }
        // Error de red o 5xx: detener y reintentar más tarde.
        break;
      }
    }
  } finally {
    syncing = false;
  }
}

let started = false;
export function startSyncManager() {
  if (started) return;
  started = true;
  const trigger = () => syncNow();
  window.addEventListener("online", trigger);
  window.addEventListener("focus", trigger);
  setInterval(trigger, 20000);
  trigger();
}
